import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'promotion',
    meta:{hidden:true,title:"下载注册"},
    component: () => import(/* webpackChunkName: "about" */ '../views/promotion.vue')
  },
  {
    path: '/luckyDraw',
    name: 'luckyDraw',
    meta:{hidden:true,title:"邀请好友助力"},
    component: () => import(/* webpackChunkName: "about" */ '../views/luckyDraw.vue')
  },
  

]

const router = createRouter({
  base: "/shareUrl/", 
  //base: "/invitation/", 
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  console.log(to,'to----------------')
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
